import React from 'react'

export function ShinyButton({ children, className, ...props }) {
  return (
    <button
      style={{
        position: 'relative',
        display: 'inline-flex',
        height: '2.75rem',
        cursor: 'pointer',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '0.75rem',
        border: '0',
        backgroundSize: '200%',
        padding: '0.5rem 2rem',
        fontSize: '1rem',
        fontWeight: '500',
        transition: 'color 0.3s',
        backgroundClip: 'padding-box, border-box, border-box',
        backgroundOrigin: 'border-box',
        border: 'calc(0.08 * 1rem) solid transparent',
        outline: 'none',
        boxShadow: '0 0 0 0.2rem var(--ring)',
        pointerEvents: 'auto',
        opacity: '1',
        color: 'white',
        backgroundImage:
          'linear-gradient(#121213, #121213), linear-gradient(#121213 50%, rgba(18, 18, 19, 0.6) 80%, rgba(18, 18, 19, 0)), linear-gradient(90deg, #ff00ff, #ff66ff, #ff99ff, #ffccff, #ff00ff)'
      }}
      {...props}>
      {children}
      <div
        style={{
          position: 'absolute',
          bottom: '-20%',
          left: '50%',
          zIndex: '0',
          height: '20%',
          width: '60%',
          transform: 'translateX(-50%)',
          backgroundImage: 'linear-gradient(90deg, #ff00ff, #ff66ff, #ff99ff, #ffccff, #ff00ff)',
          filter: 'blur(calc(0.8 * 1rem))'
        }}
      />
    </button>
  )
}
